import styled from 'styled-components';

export const clsPrefix = 'list-item-title-tag-description';

export const cssClasses = {
  wrapper: clsPrefix,
  title: `${clsPrefix}-title`,
  tags: `${clsPrefix}-tags`,
  tag: `${clsPrefix}-tag`,
  description: `${clsPrefix}-description`,
} as const;

export const ListItemTitleTagDescriptionSC = styled.div`
  .${cssClasses.title} {
    margin-bottom: 8px;
    ${({ theme }) => theme.mappedTypography.overline.default};
  }

  .${cssClasses.tags} {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;

    .${cssClasses.tag} {
      margin-bottom: 8px;
    }
  }

  .${cssClasses.description} {
    color: ${({ theme }) => theme.color.tint.secondary};
    ${({ theme }) => theme.mappedTypography.captionLarge.default};
  }
`;
